/*
 * Sunboost custom section — not part of Dawn.
 * Created: 2026-04-14
 * Web component <sb-about-preview> — scroll-wipe animation host.
 * Mirrors Publisher block ai_gen_block_fe4358e.liquid L292–L319.
 */

if (!customElements.get('sb-about-preview')) {
  class SbAboutPreview extends HTMLElement {
    connectedCallback() {
      const prefersReducedMotion =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion || this.dataset.animate === 'false') {
        return;
      }

      if (typeof IntersectionObserver !== 'function') {
        // Graceful degradation — show content at resting state.
        return;
      }

      this.classList.add('animate-ready');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('animate-visible');
              observer.unobserve(this);
            }
          });
        },
        { threshold: 0.15 }
      );

      observer.observe(this);
    }
  }

  customElements.define('sb-about-preview', SbAboutPreview);
}
